<script lang="ts">
  import { onMount } from "svelte";

  export let start: number;
  export let index = 0;

  let ready = false;
  let container: HTMLElement;
  let spacing = 0;
  let gap = 24;

  function updateSpacing() {
    const slides = Array.from(container.children) as Array<HTMLElement>;

    spacing = slides.length ? (container.offsetWidth - slides[0].offsetWidth) / 2 : 0;
  }

  const detectCurrent = () => {
    updateSpacing();

    requestAnimationFrame(() => {
      // Offset by spacing because it won't be factored into rendering yet
      const goal = container.scrollLeft + container.offsetWidth / 2;
      const slides = Array.from(container.children) as Array<HTMLElement>;

      // Find item closest to the goal
      let nextIndex = slides.findIndex((el) => {
        let left = el.offsetLeft - 0.5 * gap;
        let right = left + el.offsetWidth + gap;

        return left < goal && right > goal;
      });

      if (nextIndex >= 0) {
        index = nextIndex;
        ready = true;
      }
    });
  };

  onMount(() => {
    detectCurrent();

    if (start) {
      requestAnimationFrame(() => {
        let slide = container.children.item(start);

        slide?.scrollIntoView({ behavior: "auto" });
      });
    }
  });
</script>

<svelte:window on:resize={detectCurrent} />

<div
  class="Container hide-scroll"
  class:ready
  bind:this={container}
  on:scroll={detectCurrent}
  style="--slide-gap: {gap}px; --spacing: {spacing}px;"
>
  <slot />
</div>

<style>
  .Container {
    display: flex;
    flex: 1 1 calc(100% - 140px);
    grid-gap: var(--slide-gap);
    opacity: 0;
    overflow-x: scroll;
    padding-bottom: 18px;
    padding-left: var(--spacing);
    padding-right: var(--spacing);
    padding-top: max(32px, 5vh);
    scroll-padding-left: var(--spacing);
    scroll-padding-right: var(--spacing);
    scroll-snap-type: x mandatory;
    touch-action: pan-x;
    transition: 0.2s opacity;
    width: 100%;
  }

  .Container.ready {
    opacity: 1;
  }
</style>
